<template>
    <div class="m-cont">
        <div class="nav-sale">
            <div class="con-sal">
                <span>
                    <a href="#" class="btn btn-outline-success btn-sm" @click="home">Home</a>
                </span>
                AGGIUNTE
                <div class="search-box">
                    <input type="text" v-model="searchQuery" placeholder="Cerca prodotto..." class="filter-input-aggiunte">
                </div>
            </div>
        </div>    
        <div class="tab-cont" id="style-3">
            <table class="table">
                <thead class="thead-dark">
                    <tr>
                        <th class="text">Prodotto</th>
                        <th class="text">Quantità Aggiunta</th>
                        <th class="text">Prezzo Aggiunta</th>
                    </tr>
                    </thead>
                    <tbody >
                        <tr v-for="(prodotto, index) in filteredProdotti" :key="index">
                            <td class="text pointer" ><input v-model="prodotto.descrizio" disabled /></td>
                            <td class="text" ><input type="number" min="0" v-model="prodotto.quantitaAggiunta" @input="()=> updateQuantita(prodotto.code,null,null,null,prodotto.quantitaAggiunta,null)"/></td>
                            <td class="text" ><input type="number" min="0" v-model="prodotto.prezzoAggiunta" @input="()=> updateQuantita(prodotto.code,null,null,null,null,prodotto.prezzoAggiunta)"/></td>
                        </tr>
                    </tbody>
            </table>
        </div> 
    </div>
</template>


<script>
// @ is an alias to /src
import { store } from '../store/store.js'

export default {
  name: 'TabellaMapP',
  data: function () {
            return {
                prodotti:[],
                quantita:'',
                searchQuery: '',
                store

            }
   },
  methods: {
    home() {
        this.$router.push({ name: "Gestionale"})
    },
    displayProduct() {
        this.axios.post(this.store.path+'displayProduct',{headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                console.log('Prodotti caricati con successo')
            }else{console.log('Non è stato possibile caricare i prodotti')}
            response.data.messaggio.forEach(element => {
                  element.prezzo=element.prezzo?element.prezzo:0;
                  element.quantitamin=element.quantitamin?element.quantitamin:0; 
                  element.quantitaordine=element.quantitaordine?element.quantitaordine:0;
                  element.stato=element.stato?element.stato:'';
                  element.quantitaAggiunta=element.quantitaAggiunta?element.quantitaAggiunta:0;
                  element.prezzoAggiunta=element.prezzoAggiunta?element.prezzoAggiunta:0;
                  this.prodotti.push(element);
            });
        })
    },
    updateQuantita(code,quantita,quantitamin,quantitaordine,quantitaAggiunta,prezzoAggiunta) {
        this.axios.post(this.store.path+'updateQuantita',{code:code,quantita:quantita,quantitamin:quantitamin,quantitaordine:quantitaordine,quantitaAggiunta:quantitaAggiunta,prezzoAggiunta:prezzoAggiunta,headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                console.log('Prodotti caricati con successo')
            }else{console.log('Non è stato possibile caricare i prodotti')}
            response.data.messaggio.forEach(element => {
                  this.prodotti.push(element);
            });
        })
    },
    updatePrezzo(code,prezzo) {
        this.axios.post(this.store.path+'updatePrezzo',{code:code,prezzo:prezzo,headers:{
      authorization: `Bearer  ${JSON.parse(localStorage.token)}`}}).then((response) => {
            // carico le sale e le mostro 
            // axios.defaults.headers.common['Authorization'] = 'Bearer ' + r.data.token;
            //localStorage.setItem( 'token', JSON.stringify(response.data.token) );
            //this.$router.push({ name: "Gestionale", params :{data:`Ben Tornato ${this.nomeUtente}`,token: response.data.token} })
            console.log(response.data.messaggio)
            if(response.data.messaggio){
                console.log('Prodotti caricati con successo')
            }else{console.log('Non è stato possibile caricare i prodotti')}
            response.data.messaggio.forEach(element => {
                  this.prodotti.push(element);
            });
        })
    },
  },
  computed: {
    filteredProdotti() {
        if (!this.prodotti) return [];
        const query = (this.searchQuery || '').toLowerCase().trim();
        if (!query) return this.prodotti;
        
        return this.prodotti.filter(prodotto => {
            const desc = (prodotto.descrizio || '').toLowerCase();
            const nome = (prodotto.nome || '').toLowerCase();
            const code = (prodotto.code || '').toLowerCase();
            return desc.includes(query) || nome.includes(query) || code.includes(query);
        });
    }
  },
  
  beforeMount() {
      this.displayProduct();
  },
  
}
</script>



<style scoped>
.m-cont {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 10px;
    height: 100vh;
}
.con-sal {
    display: flex;
    flex-direction: column;
}
.nav-sale{
    flex-basis: auto;
    min-height: 15vh;
}

.tab-cont {
    margin: auto;
    margin-top: 20px;
    background: #F5F5F5;
    overflow-y: scroll;
    flex-basis: 80%;
    width: 100vw;
}


#style-3::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar
{
  width: 6px;
  background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar-thumb
{
  background-color: #000000;
}

.table,tr {
    width: 100vw;
}

thead {
    position: sticky;
    top: 0;
}
th,td {
    width: 33.3vw;
}
</style>